<template>
  <div>
    <div class="py-7.5 grid md:grid-cols-2 lg:grid-cols-3 gap-4 xl:gap-10">
      <div
        v-for="(ach, index) in achs"
        :key="`my-ach-account-${index}`"
        class="p-7.5 bg-white border border-dark-b rounded-lg"
      >
        <p class="font-bold text-2xl">{{ ach.accountHolderName }}</p>
        <div class="py-5">
          <p>{{ ach.bankName }}</p>
          <p>**** {{ ach.last4 }}</p>
        </div>
        <div class="pt-5 flex">
          <button
            class="flex items-center text-sm text-dark"
            :disabled="deleteArchAccount"
            @click="deleteAccount(ach.id)"
          >
            <i class="icon-remove mr-2" />
            <span class="opacity-50 pt-1">Remove</span>
          </button>
          <button
            class="flex items-center text-sm text-blue ml-4"
            @click="verifyAccount(ach.id)"
          >
            <i class="icon-refresh mr-2" />
            <span class="pt-1">Verify</span>
          </button>
        </div>
      </div>
      <button
        class="bg-white border border-dark-b rounded-lg flex items-center justify-center py-24"
        @click="isAchModalOpen = true"
      >
        <div class="leading-6 text-blue font-medium text-xl">
          <p>+</p><p>Add New</p><p>Account</p>
        </div>
      </button>
    </div>
    <NewAchModal v-if="isAchModalOpen" @close="closeNewModal" />
    <VerifyAchAccountModal
      v-if="isVerifyModalOpen"
      :id="selectedAchToVerify"
      @close="closeVerifyModal"
    />
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import NewAchModal from '@/shared/components/profile/payment/NewAchModal'
import VerifyAchAccountModal from '@/shared/components/profile/payment/VerifyAchAccountModal'

export default {
  name: 'AccountPayment',
  props: {
    achs: {
      type: Array,
      default: () => []
    }
  },
  components: {
    NewAchModal,
    VerifyAchAccountModal
  },
  data() {
    return {
      deleteArchAccount: false,
      isAchModalOpen: false,
      isVerifyModalOpen: false,
      selectedAchToVerify: null
    }
  },
  methods: {
    ...mapActions ([
      'deleteBuyerAchAccount'
    ]),
    async deleteAccount(id) {
      if(this.deleteArchAccount) return
      this.deleteArchAccount = true;
      const response = await this.deleteBuyerAchAccount(id)
      if (response.result) this.$emit('fetchAchs')

      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message,
        duration: 7000
      })
      this.deleteArchAccount = false;
    },
    verifyAccount(id) {
      this.selectedAchToVerify = id
      this.isVerifyModalOpen = true
    },
    closeNewModal(added) {
      this.isAchModalOpen = false
      if (added) this.$emit('fetchAchs')
    },
    closeVerifyModal() {
      this.isVerifyModalOpen = false
      this.selectedAchToVerify = null
    }
  }
}
</script>